<template>
    <div class="bt b--light-gray bg-near-white ph3 ph4-ns mid-gray flex items-cente" @click="$emit('click')" style="padding-top: 22px; padding-bottom: 22px;">
        <h6> {{categoryName}} </h6> 
    </div>
</template>

<script>
export default {
    props: {
        categoryName: {
            type: String
        }
    }
};
</script>
